__turbopack_context__.v({
  "toggle_btn_avn": "wFguMW_toggle_btn_avn",
  "toggle_btn_sts": "wFguMW_toggle_btn_sts",
});
